/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-20 11:14:07
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-09 14:03:57
 * @FilePath: /src/app/payment/components/GlobalPay/KlarnaPay/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

'use client';

import { createKlarnaSession, klarnaPay } from '@/api/pay';
import { toast } from '@/components/Toast';
import { useStore } from '@/providers/app-store-provider';
import logger from '@/utils/client-logger';
import { useEffect, useImperativeHandle, useState } from 'react';

interface KlarnaPayProps {
  ref: React.RefObject<any>;
  order: any;
  from: string;
  billingAddress?: any;
  shippingAddress?: any;
  currPayMethod: string;
  cartIds?: string[];
  paySuccess: () => void;
  payFail: (msg?: string) => void;
  children?: React.ReactNode;
}

const COUNTRY_TABLE = {
  DE: 'en-DE',
  GB: 'en-GB',
  IT: 'en-IT',
  US: 'en-US',
  FR: 'en-FR',
  CA: 'en-CA',
};

export default function KlarnaPay({ ref, children, from, ...props }: KlarnaPayProps) {
  useImperativeHandle(ref, () => ({
    payAction,
  }));

  const [order, setOrder] = useState<any>(props.order);

  const [paymentMethodCategories, setPaymentMethodCategories] = useState([]);

  const currency = useStore((state) => state.currency);
  const userInfo = useStore((state) => state.userInfo);

  const payAction = (_order: any) => {
    setOrder(_order);
    const _paymentMethodCategories = paymentMethodCategories.map((item) => item.identifier);
    let billing: any = {};
    let shipping: any = {};
    if (from === 'payment') {
      billing = props.billingAddress;
      shipping = props.shippingAddress;
    } else {
      billing = _order.billing_address_info;
      shipping = _order.shipping_address_info;
    }

    const orderParams = {
      purchase_country: shipping.country_id,
      purchase_currency: from === 'payment' ? currency.name : _order.purchase_currency,
      locale: COUNTRY_TABLE[shipping.country_id],
      billing_address: {
        given_name: billing.firstname,
        family_name: billing.lastname,
        email: userInfo.email,
        street_address: billing.street,
        postal_code: billing.postcode,
        city: billing.city,
        region: billing.region_code,
        phone: billing.telephone,
        country: billing.country_id,
      },
      shipping_address: {
        given_name: shipping.firstname,
        family_name: shipping.lastname,
        email: userInfo.email,
        street_address: shipping.street,
        postal_code: shipping.postcode,
        city: shipping.city,
        region: shipping.region_code,
        phone: shipping.telephone,
        country: shipping.country_id,
      },
      order_amount: from === 'order' ? _order.order_amount : _order.klarna.order_amount,
      // order_tax_amount: 0,
      order_lines: from === 'order' ? _order.order_lines : _order.klarna.order_lines,
    };

    try {
      window.Klarna &&
        window.Klarna.Payments.authorize(
          {
            payment_method_categories: _paymentMethodCategories,
            instance_id: '123',
          },
          orderParams,
          async function (res) {
            if (res.show_form && res.approved) {
              const _res = await klarnaPay({
                token: res.authorization_token,
                order_id: _order.order_id,
              });
              if (_res.code === 200) {
                window.location.replace(_res.data.redirect_url);
              } else {
                toast.error(res.msg);
                props.payFail(res.msg);
              }
            }
          },
        );
    } catch (error) {
      logger.log('error', error);
      props.payFail();
    }
  };

  const createSession = async () => {
    const params: any = {};

    if (from === 'payment') {
      params.currency = currency.name;
      params.card_ids = props.cartIds;
      params.billing_address_id = props.billingAddress.id;
      params.shipping_address_id = props.shippingAddress.id;
    } else {
      params.currency = order.purchase_currency;
      params.order_id = order.order_id;
      params.billing_address_id = order.billing_address_info.id;
      params.shipping_address_id = order.shipping_address_info.id;
    }

    const ret = await createKlarnaSession(params);
    if (ret.code === 200) {
      setPaymentMethodCategories(ret.data.payment_method_categories);

      window.Klarna &&
        window.Klarna.Payments.init({
          client_token: ret.data.client_token,
        });
    }
  };

  useEffect(() => {
    if (props.currPayMethod === 'klarna' || props.shippingAddress.country_id) {
      createSession();
    }
  }, [props.currPayMethod, props.shippingAddress.country_id]);

  return <div>{children && children}</div>;
}
